export default "__VITE_ASSET__05a6ac3a__"